/**
 * SNACKL Warenkorb-Upsell: +1 Probierpaket (9 Sticks) fuer 19,16 EUR
 * Markup: snippets/cart-upsell.liquid (wird in snippets/cart-footer.liquid gerendert)
 *
 * 1. Klick auf den Button legt das Zusatzpaket (probierpaket-extra-9er) in den Warenkorb.
 *    Die Property "_upsell" markiert die Position in den Bestellungen (fuer die Auswertung).
 * 2. Waechter: Das Zusatzpaket darf nur 1x und nur zusammen mit einem Probierpaket
 *    (9er, 27er oder 54er, kein Abo) im Warenkorb liegen.
 *    Sonst wird es automatisch angepasst bzw. entfernt.
 */
(function () {
  if (window.__snacklCartUpsell) return;
  window.__snacklCartUpsell = true;

  var UPSELL_HANDLE = 'probierpaket-extra-9er';
  var PACK_HANDLES = ['snackl-probierpaket'];

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch;
  var busy = false;
  var again = false;

  function post(path, body) {
    return origFetch.call(window, root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          throw new Error(json.description || json.message || 'Cart error');
        });
      }
      return response.json();
    });
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  }

  // Waechter: max. 1 Zusatzpaket, nur zusammen mit einem Probierpaket
  function guard() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    again = false;
    return origFetch.call(window, root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var upsellLines = [];
        var upsellQty = 0;
        var hasPack = false;
        (cart.items || []).forEach(function (item) {
          if (item.handle === UPSELL_HANDLE) {
            upsellLines.push(item);
            upsellQty += item.quantity;
          } else if (!item.selling_plan_allocation && PACK_HANDLES.indexOf(item.handle) !== -1) {
            hasPack = true;
          }
        });
        if (!upsellLines.length) return false;
        var allowed = hasPack ? 1 : 0;
        if (upsellQty <= allowed) return false;
        // Erste Position auf das Erlaubte setzen, weitere Positionen entfernen
        var updates = {};
        upsellLines.forEach(function (item, index) {
          updates[item.key] = index === 0 ? allowed : 0;
        });
        return post('cart/update.js', { updates: updates }).then(function () { return true; });
      })
      .then(function (changed) {
        busy = false;
        if (again) setTimeout(guard, 50);
        if (changed) {
          refreshCart();
          if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
        }
      })
      .catch(function (error) {
        busy = false;
        console.error('[SNACKL Upsell]', error);
      });
  }

  // Nach jeder Warenkorb-Aenderung pruefen
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      request.then(function () { setTimeout(guard, 60); }).catch(function () {});
    }
    return request;
  };

  // Button "Fuer 19,16 EUR hinzufuegen"
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-upsell]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    button.style.opacity = '0.6';

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    var upsellLabel = button.getAttribute('data-upsell-label') || 'warenkorb-upsell';

    post('cart/add.js', {
      items: [{ id: variantId, quantity: 1, properties: { _upsell: upsellLabel } }]
    })
      .then(refreshCart)
      .catch(function (error) {
        console.error('[SNACKL Upsell]', error);
        var errorEl = document.getElementById('cart-errors');
        if (errorEl) {
          errorEl.textContent = 'Hinzufügen gerade nicht möglich. Bitte versuche es erneut.';
        }
        button.removeAttribute('aria-busy');
        button.style.opacity = '';
        refreshCart();
      });
  }, true); // Capture-Phase: der Warenkorb-Drawer stoppt Klicks sonst vor dem document

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard);
  else guard();
})();